import { Form, Input, Button, Typography, Card } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "../../../context/AlertProvider";
import {
  createAccountRole,
  getAllRoles,
  updateAccountRole,
} from "../../../actionCreator/roleManagementActionCreator";

const { Paragraph } = Typography;

const CreateRoleForm = ({ initialValues, closeModal, callback }) => {
  const [form] = Form.useForm();
  const { showAlert } = useAlert();
  const dispatch = useDispatch();
  const roles = useSelector((state) => state.roleManagementReducer.roles);
  const [error, setError] = useState();

  const onFinish = async (values) => {
    const parentRole = roles?.roles[roles?.roles?.length - 1]?.parentRole;
    const res = initialValues?.id
      ? await dispatch(updateAccountRole({ id: initialValues?.id, ...values }))
      : await dispatch(
          createAccountRole({ ...values, parentRole: parseInt(parentRole) + 1 })
        );
    if (res?.status === 201 || res?.status === 200) {
      showAlert(
        "success",
        initialValues?.id
          ? `Role "${values.name}" updated successfully!`
          : `Role "${values.name}" created successfully!`
      );
      callback && callback(res?.data?.name);
      form.resetFields();
      dispatch(getAllRoles());
      closeModal && closeModal();
    } else {
      setError(res?.response?.data?.title);
      showAlert("error", res?.response?.data?.title);
    }
  };

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  return (
    <Card
      title={
        <div className="text-theme heading18px">
          {initialValues?.id ? "Edit Role" : "Create New Role"}
        </div>
      }
      className="rounded-2xl shadow-md"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={(changedValues, allValues) => {
          setError();
        }}
      >
        {error && <p className="text-error text-center pb-2">{error}</p>}

        <Form.Item
          label={<div className="fw-medium">Role Name</div>}
          name="name"
          rules={[{ required: true, message: "Role name is required" }]}
        >
          <Input placeholder="Enter role name" />
        </Form.Item>
        {initialValues?.id ? (
          <Paragraph className="text-color-6E6E6E">
            After saving, you can adjust permissions in the Permission Matrix
            tab.
          </Paragraph>
        ) : (
          <>
            <Paragraph className="text-color-6E6E6E">
              New roles will have <strong>View</strong> permission enabled by
              default for all modules.
            </Paragraph>
            <Paragraph className="text-color-6E6E6E">
              You can customize other permissions after role creation using the
              permission matrix.
            </Paragraph>
          </>
        )}
        <div className="d-flex align-items-center justify-content-end gap-20 mt10">
          {!!initialValues?.id && (
            <Button className="secondary-btn" onClick={closeModal}>
              Cancel
            </Button>
          )}
          <Button
            type="primary"
            className="theme-btn"
            htmlType="submit"
            block={!initialValues?.id}
          >
            {initialValues?.id ? "Save Changes" : "Create Role"}
          </Button>
        </div>
      </Form>
    </Card>
  );
};

export default CreateRoleForm;
